import base from '../dr-base'
import drSimpleLayout from './dr-simple-layout.vue'

const schema = {
  $Type: 'dr-simple-layout',
  name: 'Container',
  group: 'Container widgets',
  icon: 'square-full',
  ...base,
  properties: {
    ...base.properties,
    Widgets: {
      type: 'array'
    },
    Visible: {
      name: 'vuetifyWidgets.dr-simple-layout.visible',
      type: 'string'
    }
  }
}

export default {
  schema,
  component: drSimpleLayout
}